import React from "react";
import "./textcarosul.css";

function TextCarosul() {
  return (
    <div className="stock-ticker">
      <div className="stock-ul">
        <div className="stock-li stock-item-1">
          <img
            src={"/images/leftwing.png"}
            className="wings"
            alt="leftwing"
            loading="lazy"
            decoding="async"
          />
          <span>
            BeFiSc wins the{" "}
            <span style={{ color: "#B6FF00" }}>
              Fintech Innovation of the Year&nbsp;&nbsp;&nbsp;
            </span>
            Award&nbsp;&nbsp;🎉
          </span>

          <img
            src="/images/bwimage.png"
            alt="bwimage"
            className="bussiness-world"
            loading="lazy"
            decoding="async"
          />
          <img
            src={"/images/rightwing.png"}
            className="wings"
            alt="rightwing"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="stock-li stock-item-2">
          <img
            src={"/images/leftwing.png"}
            className="wings"
            alt="leftwing"
            loading="lazy"
            decoding="async"
          />
          {/* <span>
            BeFiSc launches &nbsp;&nbsp;
            <span style={{ color: "#B6FF00" }}>
              UAN History V3 API &nbsp;&nbsp;
            </span>
            to make employee background checks more accurate and reliable.
            &nbsp;&nbsp;🎉
          </span> */}
          <span>
            BeFiSc launches &nbsp;&nbsp;
            <span style={{ color: "#B6FF00" }}>
              PDF Tampering Detection API &nbsp;&nbsp;
            </span>
            to ensure document authenticity with advanced integrity checks.
            &nbsp;&nbsp;🎉
          </span>

          <img
            src={"/images/rightwing.png"}
            className="wings"
            alt="rightwing"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="stock-li stock-item-3">
          <img
            src={"/images/leftwing.png"}
            className="wings"
            alt="leftwing"
            loading="lazy"
            decoding="async"
          />
          <span>
            BeFiSc Reaches a&nbsp;&nbsp;
            <span style={{ color: "#B6FF00" }}>
              Milestone 150 Clients&nbsp;&nbsp;
            </span>
            and Counting!&nbsp;&nbsp;🎉
          </span>

          <img
            src={"/images/rightwing.png"}
            className="wings"
            alt="rightwing"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="stock-li stock-item-4">
          <img
            src={"/images/leftwing.png"}
            className="wings"
            alt="leftwing"
            loading="lazy"
            decoding="async"
          />
          {/* <span>
            BeFiSc launches &nbsp;&nbsp;
            <span style={{ color: "#B6FF00" }}>
              PAN Demographic V2 API &nbsp;&nbsp;
            </span>
            for quick and easy PAN verification. &nbsp;&nbsp;🎉
          </span> */}
          <span>
            BeFiSc launches &nbsp;&nbsp;
            <span style={{ color: "#B6FF00" }}>
              Document OCR API &nbsp;&nbsp;
            </span>
            to automate document reading with AI precision. &nbsp;&nbsp;🎉
          </span>

          <img
            src={"/images/rightwing.png"}
            className="wings"
            alt="rightwing"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </div>
  );
}

export default React.memo(TextCarosul);
